<div ngbDropdown class="header-toolbar-item" autoClose="outside">
  <span
    placement="bottom-right"
    container="body"
    [ngbTooltip]="
      this.filteredRowCount > rowCount
        ? 'More than ' +
          rowCount +
          ' accounts in filter. Refine your filter to enable actions'
        : ''
    "
  >
    <button
      ngbDropdownToggle
      nf-icon-button
      icon="dots-vertical"
      class="filter-actions-button"
      placement="bottom-right"
      container="body"
      aria-labelledby="filter-actions-button"
      (click)="onToggleDropdown()"
    >
      Filter Actions
    </button>
  </span>
  <div
    ngbDropdownMenu
    class="dropdown-menu dropdown-menu-right"
    *nfLoader="showLoader"
  >
    <button
      id="filterActionDropdown"
      class="dropdown-item btn btn-link"
      *ngFor="let action of filterActions; index as i"
      (click)="action.action()"
      [disabled]="action.isDisabled"
      aria-labelledby="action.label"
    >
      <span
        *ngIf="isLoadingData(i)"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      {{ action.label }}
    </button>
  </div>
</div>
